import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-311" data-mp="3k06x1v86utys">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] ${dark ? 'text-gold-light' : 'text-gold'}`} data-id="element-312" data-mp="3k29j646802y8">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[30px] font-extrabold leading-[1.12] sm:text-5xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-313" data-mp="gjq2lywwmlj9">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-[17px] leading-relaxed sm:text-lg ${dark ? 'text-white/80' : 'text-ink-muted'}`} data-id="element-314" data-mp="6tdksegh56gt">
          {intro}
        </p>}
    </div>;
}